// extracted by mini-css-extract-plugin
export default {"Label":"Styles_Label__tHo5n","InputContainer":"Styles_InputContainer__vQheM","InputInvalid":"Styles_InputInvalid__NpbFs","InvalidLabel":"Styles_InvalidLabel__rJuT+"};